import React, { useState } from "react";
import styles from "./Header.module.scss";
import imgLogo from "../../../assets/images/logo.png";
import {
  Warning,
  Button
} from "@onegovbugs/onegov-react-components";
import userManager from "../../../userManager";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import LogoutConfirmation from './LogoutConfirmation';
import { useTimer } from "../timer/Timer";
import IdleTimer from "react-idle-timer";
import { useDispatch } from "react-redux";
import { saveApplication } from "../../../redux/actions";
import { getUrlWithStepNumber } from "../../../utils/NavigationHelper";

const Header = props => {
  const oidc = useSelector(state => state.oidc);
  const [logoutMode, setLogoutMode] = useState(false);
  const application = useSelector(state => state.application);

  const { addTimer, removeTimer, Count } = useTimer();
  const dispatch = useDispatch();

  return (
    <>
      {props.match.path !== "/" &&
        props.match.path !== "/tattooist-form/prerequisites" && props.match.path !== "/operator/prerequisites" ? (
          oidc.user && (
            <div className={`row`}>
              <div className={`col-12`}>
                {
                  <IdleTimer
                    timeout={1000 * 30 * 60}
                    onActive={(e) => {
                      removeTimer("timerformidle");
                    }}
                    onIdle={(e) => {
                      addTimer(
                        "timerformidle",
                        60
                      );
                    }}
                  />
                }
                <Count on={"timerformidle"}>
                  {(props) => {
                    const { minutes, seconds, completed } = props.timeDelta;

                    if (completed) {
                      setLogoutMode(true);
                      dispatch(
                        saveApplication(getUrlWithStepNumber(window.location.pathname), () => {
                          userManager.signoutRedirect();
                        })
                      );

                      return null;
                    }

                    return (
                      <div className={styles.headline}>
                        <div className={styles.siteContainer}>
                          You will be logged out in{" "}
                          <strong>
                            {minutes} minutes {seconds} seconds{" "}
                          </strong>
                        </div>
                      </div>
                    );
                  }}
                </Count>
              </div>
            </div>
          )) : null}
      <div className={styles.logoContainer}>
        <div className={`row`}>
          <div className={`col-8`}>
            <img
              src={imgLogo}
              alt={props.type === undefined ? "NSW Government Tattooist Logo" : "NSW Government Tattoo Operator Logo"}
              className={styles.logo}
            />
          </div>
          <div className={`col-4 ${styles.logoutCont}`}>
            {
              (props.match.path !== "/tattooist-form/prerequisites" || props.match.path !== "/operator/prerequisites") ? (
                oidc.user ? (
                  <Button secondary onClick={() => userManager.signoutRedirect()}>
                    Logout
                  </Button>
                ) : (
                    <Button secondary onClick={() => userManager.signinRedirect()}>
                      Login
                    </Button>
                  )
              ) : null}
          </div>
        </div>
        {logoutMode == true && (<LogoutConfirmation onLogoutClick={() => {
          userManager.signoutRedirect();
        }} onClickClose={() => { setLogoutMode(false); }} />)}
      </div></>
  );
};

export default withRouter(props => <Header {...props} />);
